module.exports = __webpack_public_path__ + "img/whatsapp-icon.ddf77df3.png";